import type { DailyGoal } from './useDailyGoals';

// Helper to format date as YYYY-MM-DD (UTC - used only for "today" in mock data)
const formatDate = (date: Date): string => {
  return date.toISOString().split('T')[0];
};

const today = new Date();

export const mockDailyGoalsData: DailyGoal[] = [
  // Today's data - evenly split: 7 Emerald (76-100%), 7 Amber (51-75%), 6 Red (0-50%)
  // Emerald providers (76-100% scheduled)
  {
    providerId: '883e4243-7449-4503-a56e-80e6f1a284ed',
    providerName: 'Tabitha Hartmann',
    date: '2025-01-30',
    goal: 6000,
    scheduledProduction: 1200, // 20%
    completedProduction: 0,
  },
  {
    providerId: 'p2',
    providerName: 'Roel Lebsack',
    date: formatDate(today),
    goal: 8000,
    scheduledProduction: 6800, // 85%
    completedProduction: 6000,
  },
  {
    providerId: 'p3',
    providerName: 'Norbert Turner',
    date: formatDate(today),
    goal: 10000,
    scheduledProduction: 9000, // 90%
    completedProduction: 7500,
  },
  {
    providerId: 'p4',
    providerName: 'Unknown',
    date: formatDate(today),
    goal: 5500,
    scheduledProduction: 5060, // 92%
    completedProduction: 4500,
  },
  {
    providerId: 'p5',
    providerName: 'Willa Harvey',
    date: formatDate(today),
    goal: 7000,
    scheduledProduction: 6160, // 88%
    completedProduction: 5500,
  },
  {
    providerId: '0964f07c-d7ed-4907-9cf2-7e3276219194',
    providerName: 'Yoshiko Kuhic',
    date: '2025-01-30',
    goal: 9000,
    scheduledProduction: 7380, // 82%
    completedProduction: 6500,
  },
  {
    providerId: 'p7',
    providerName: 'Clair Zieme',
    date: formatDate(today),
    goal: 6000,
    scheduledProduction: 5700, // 95%
    completedProduction: 5100,
  },
  // Amber providers (51-75% scheduled)
  {
    providerId: 'p8',
    providerName: 'Annetta Block',
    date: formatDate(today),
    goal: 12000,
    scheduledProduction: 7200, // 60%
    completedProduction: 6500,
  },
  {
    providerId: 'p9',
    providerName: 'Stephanie Parisian-Walker',
    date: formatDate(today),
    goal: 7500,
    scheduledProduction: 4875, // 65%
    completedProduction: 4000,
  },
  {
    providerId: '08d26cf3-b28f-4967-b4a1-4b5155a0614e',
    providerName: 'Linda Rohan',
    date: '2025-01-30',
    goal: 6500,
    scheduledProduction: 4550, // 70%
    completedProduction: 3800,
  },
  {
    providerId: 'p11',
    providerName: 'Jermey Hermiston',
    date: formatDate(today),
    goal: 8500,
    scheduledProduction: 4675, // 55%
    completedProduction: 3500,
  },
  {
    providerId: 'p12',
    providerName: 'Wilhelmine Fadel',
    date: '2025-01-28',
    goal: 7000,
    scheduledProduction: 6040, // 72%
    completedProduction: 4200,
  },
  {
    providerId: 'p13',
    providerName: 'Esmeralda Murphy',
    date: formatDate(today),
    goal: 6500,
    scheduledProduction: 4420, // 68%
    completedProduction: 3600,
  },
  {
    providerId: 'd8c2c0e7-2491-41c6-bb7d-5231e47cb8b3',
    providerName: 'Leo Adams',
    date: '2025-01-30',
    goal: 8000,
    scheduledProduction: 4960, // 62%
    completedProduction: 4000,
  },
  // Red providers (0-50% scheduled)
  {
    providerId: 'p15',
    providerName: 'Angelo Wuckert',
    date: formatDate(today),
    goal: 9000,
    scheduledProduction: 2700, // 30%
    completedProduction: 2000,
  },
  {
    providerId: 'p16',
    providerName: 'Kacey Blick',
    date: formatDate(today),
    goal: 6000,
    scheduledProduction: 2400, // 40%
    completedProduction: 1800,
  },
  {
    providerId: 'p17',
    providerName: 'Alexandra Reichert',
    date: formatDate(today),
    goal: 7000,
    scheduledProduction: 3150, // 45%
    completedProduction: 2500,
  },
  {
    providerId: 'p18',
    providerName: 'Rahsaan Vandervort',
    date: formatDate(today),
    goal: 8500,
    scheduledProduction: 2125, // 25%
    completedProduction: 1500,
  },
  {
    providerId: 'p19',
    providerName: 'Will Towne',
    date: formatDate(today),
    goal: 7500,
    scheduledProduction: 2625, // 35%
    completedProduction: 2000,
  },
  {
    providerId: 'p20',
    providerName: 'Vincenzo Collier',
    date: formatDate(today),
    goal: 9500,
    scheduledProduction: 1900, // 20%
    completedProduction: 1200,
  },
  // Tabitha, Yoshiko, Linda, Leo also on today so they show when date = today + provider filter
  {
    providerId: '883e4243-7449-4503-a56e-80e6f1a284ed',
    providerName: 'Tabitha Hartmann',
    date: formatDate(today),
    goal: 6000,
    scheduledProduction: 4800,
    completedProduction: 4000,
  },
  {
    providerId: '0964f07c-d7ed-4907-9cf2-7e3276219194',
    providerName: 'Yoshiko Kuhic',
    date: formatDate(today),
    goal: 9000,
    scheduledProduction: 7380,
    completedProduction: 6500,
  },
  {
    providerId: '08d26cf3-b28f-4967-b4a1-4b5155a0614e',
    providerName: 'Linda Rohan',
    date: formatDate(today),
    goal: 6500,
    scheduledProduction: 4550,
    completedProduction: 3800,
  },
  {
    providerId: 'd8c2c0e7-2491-41c6-bb7d-5231e47cb8b3',
    providerName: 'Leo Adams',
    date: formatDate(today),
    goal: 8000,
    scheduledProduction: 4960,
    completedProduction: 4000,
  },
];

/** Return mock goals for the given date. */
export const getMockDailyGoals = (date: Date | string | null): DailyGoal[] => {
  if (date == null) return [];
  const dateStr =
    date instanceof Date ? formatDate(date) : String(date).slice(0, 10);
  return mockDailyGoalsData.filter((goal) => goal.date === dateStr);
};
